import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';

import ProductCard from '../../app-utils/card/ProductCard';

import Button from '../../components/common/button/Button';
import Icon from '../../components/common/icon/Icon';
import ErrorScreen from '../../components/derived/error/ErrorScreen';
import FeaturedCard from '../../components/common/card/FeaturedCard';
import ReviewCard from '../../app-utils/card/ReviewCard';
import Spacer from '../../components/common/spacer/Spacer';
import WriteAReview from '../../components/derived/modal/WriteAReview';

import Sidebar from '../../layouts/sidebar/Sidebar';

import Api from '../../../utils/api';

import './style.scss';

const SVG_FILE_PATH = '../../../static/images/';

const MAX_PRODUCTS = 10;
const MAX_REVIEWS = 3;
const MAX_OFFERS = 10;

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reviews: [],
      products: [],
      banners: [],
      discountIcon: null,
      productIcon: null,
      showReviewModal: false,
    };
  }

  componentWillMount() {
    const { profile } = this.props;
    const code = profile.code;
    if (code) {
      this.fetchReviews(code);
      this.fetchProducts(code);
      this.fetchBanners(code);
    }

    if (this.props.properties) {
      this.fetchIcons(this.props.properties);
    }
  }

  componentWillReceiveProps(nextProps) {
    const code = nextProps.profile.code;

    if (code) {
      this.fetchReviews(code);
      this.fetchProducts(code);
      this.fetchBanners(code);
    }

    if (nextProps.properties) {
      this.fetchIcons(nextProps.properties);
    }
  }

  fetchIcons(properties) {
    this.setState({
      discountIcon: properties.discount_icon,
      productIcon: properties.product_icon,
    });
  }

  fetchReviews(code) {
    Api.reviews(code, 1, undefined, MAX_REVIEWS).then(response =>
      this.setState({ reviews: response.results }));
  }

  fetchProducts(code) {
    Api.products(code, 1, undefined, MAX_PRODUCTS).then(response =>
      this.setState({ products: response.results }));
  }

  fetchBanners(code) {
    Api.banners(code).then(response => this.setState({ banners: response }));
  }

  render() {
    const { profile, params } = this.props;
    const storeName = profile.store_name;
    const partnerSlug = params.partnerSlug;
    const offers = _.slice(profile.offers, 0, MAX_OFFERS);

    return (
      <main id="home-body">
        <WriteAReview
          code={profile.code}
          open={this.state.showReviewModal}
          onClose={() => this.setState({ showReviewModal: false })}
        />
        <div className="customer-message">
          <img alt="drop" src={`${SVG_FILE_PATH}drop.svg`} />
          <h4>Extra Saving! </h4>
          <p>Earn mPanni Points at this store</p>
        </div>
        <div className="container-fluid">
          <div className="row" id="main-row">
            <div id="content">
              <div className="col-lg-17 col-md-17">
                <FeaturedCard id="offers">
                  <FeaturedCard.Content>
                    <FeaturedCard.Header
                      actions={
                        <Button
                          link={`/${partnerSlug}/offers`}
                          color="#ffffff"
                          label="View All"
                        />}
                      title={<h4>Store Offers</h4>}
                      media={<img role="presentation" src={this.state.discountIcon || `${SVG_FILE_PATH}store-offers.svg`} />}
                      backgroundColor="#0084FF"
                      color="#fff"
                    />
                    <FeaturedCard.Body>
                      <Spacer size={2} />
                      <Spacer size={2} />
                      {_.size(offers) > 0 ?
                        <div className="product-list">

                          {_.map(offers, offer =>
                            <ProductCard
                              key={offer.id}
                              media={
                                <img
                                  alt={offer.title}
                                  src={offer.offer_image || '/static/images/product_default.png'}
                                />}
                              title={offer.title}
                              originalPrice={_.toInteger(offer.mrp) || null}
                              price={_.toInteger(offer.discounted_price)}
                              expiry={Moment(offer.valid_to)}
                            />,
                            )}
                        </div> :
                        <ErrorScreen
                          compact
                          media={<img role="presentation" src={`${SVG_FILE_PATH}no-Discount.png`} />}
                          title="Offers coming soon"
                          helpText={`Stay updated with ${storeName}<br />` +
                                    'through m.Paani Shop Smart App'}
                        />}
                    </FeaturedCard.Body>
                  </FeaturedCard.Content>
                </FeaturedCard>

                <Spacer size={2} />

                <FeaturedCard id="products">
                  <FeaturedCard.Content>
                    <FeaturedCard.Header
                      actions={
                        <Button
                          link={`/${partnerSlug}/products`}
                          color="#ffffff"
                          label="View All"
                        />}
                      title={<h4>Store Exclusive</h4>}
                      media={<img role="presentation" src={this.state.productIcon || `${SVG_FILE_PATH}store-exclusive.svg`} />}
                      backgroundColor="#0084FF"
                      color="#ffffff"
                    />
                    <FeaturedCard.Body>
                      <Spacer size={2} />
                      {_.size(this.state.products) > 0 ?
                        <div className="product-list">
                          {_.map(this.state.products, product =>

                            <ProductCard
                              key={product.id}
                              media={
                                <img
                                  alt={product.name}
                                  src={product.image || '/static/images/product_default.png'}
                                />}
                              title={product.name}
                            />,
                          )}
                        </div> :
                        <ErrorScreen
                          compact
                          media={<img role="presentation" src={`${SVG_FILE_PATH}no-Product.png`} />}
                          title="Products coming soon"
                          helpText={`Stay updated with ${storeName}<br />` +
                                    'through m.Paani Shop Smart App'}
                        />}
                    </FeaturedCard.Body>
                  </FeaturedCard.Content>
                </FeaturedCard>

                <Spacer size={2} />

                <FeaturedCard id="reviews">
                  <FeaturedCard.Content>
                    <FeaturedCard.Header
                      actions={
                        <Button.Group>
                          <Button
                            className="review-button"
                            label="Write a review"
                            color="#0084FF"
                            backgroundColor="#ffffff"
                            borderColor=""
                            leftIcon={<Icon name="pencil" />}
                            onClick={() => this.setState({ showReviewModal: true })}
                          />
                          <Button
                            link={`/${partnerSlug}/reviews`}
                            color="#ffffff"
                            label="View All"
                          />
                        </Button.Group>}
                      title={<h4>Reviews</h4>}
                      media={<img role="presentation" src={this.state.productIcon || `${SVG_FILE_PATH}review.svg`} />}
                      backgroundColor="#0084FF"
                      color="#ffffff"
                    />
                    <div className="review-spacer" />
                    <FeaturedCard.List>
                      {_.size(this.state.reviews) > 0 ?
                        _.map(this.state.reviews, review =>
                          <ReviewCard
                            key={review.id}
                            avatar={
                              <img
                                alt={review.customer_name}
                                src={review.customer_image_url || '/static/images/user_default.png'}
                              />}
                            createdAt={Moment(review.created_at)}
                            username={review.customer_name}
                            rating={review.rating}
                            review={review.content}
                          />) :
                        <ErrorScreen
                          compact
                          media={<img role="presentation" src={`${SVG_FILE_PATH}no-Review.png`} />}
                          title="Be the first one to review"
                          helpText={`Stay updated with ${storeName}<br />` +
                                    'through m.Paani Shop Smart App'}
                        />
                      }
                    </FeaturedCard.List>
                  </FeaturedCard.Content>
                </FeaturedCard>
              </div>

              <span className="visible-xs visible-sm">
                <Spacer size={2} />
              </span>

              <Sidebar profile={this.props.profile} params={this.props.params} />
            </div>

          </div>
        </div>
      </main>);
  }
}

Home.propTypes = {
  params: PropTypes.shape({
    partnerSlug: PropTypes.string,
  }),
};

module.exports = Home;



// WEBPACK FOOTER //
// ./app/pages/home/Home.jsx